export enum DowntimeCategory {
  Mechanical = 'Mechanical',
  Maintenance = 'Maintenance',
  Electrical = 'Electrical',
}
